var _defs, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.5,33.35V169.93a10,10,0,0,0,10,10H92.4l1.12-2.31a39.95,39.95,0,1,1,69.15-.32l1.26,2.63H225.5a10,10,0,0,0,10-10V33.35a10,10,0,0,0-10-10H30.5A10,10,0,0,0,20.5,33.35ZM65.29,165.61H38.12a2.49,2.49,0,0,1-2.5-2.5V135.93a2.5,2.5,0,0,1,5,0v24.68H65.29a2.5,2.5,0,1,1,0,5Zm0-122.94H40.62V67.35a2.5,2.5,0,0,1-5,0V40.17a2.48,2.48,0,0,1,2.5-2.5H65.29a2.5,2.5,0,0,1,0,5Zm100.76,53.7H90a2.5,2.5,0,1,1,0-5h76.1a2.5,2.5,0,0,1,0,5ZM179,74.17H77a2.5,2.5,0,0,1,0-5H179a2.5,2.5,0,0,1,0,5Zm41.42,88.94a2.49,2.49,0,0,1-2.5,2.5H190.7a2.5,2.5,0,0,1,0-5h24.68V135.93a2.5,2.5,0,0,1,5,0Zm0-95.76a2.5,2.5,0,1,1-5,0V42.67H190.7a2.5,2.5,0,0,1,0-5h27.18a2.48,2.48,0,0,1,2.5,2.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128,122.54A34.95,34.95,0,1,0,163,157.48,35,35,0,0,0,128,122.54Zm0,55a20.06,20.06,0,1,1,20.06-20.06A20.08,20.08,0,0,1,128,177.54Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.06,157.48a15.06,15.06,0,1,1-15.06-15A15.07,15.07,0,0,1,143.06,157.48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.28,221.46l-15.62-7a2.46,2.46,0,0,0-2.12,0,2.52,2.52,0,0,0-1.33,1.64l-4,16.47L138,196.17a40.13,40.13,0,0,0,21.44-14.06Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118,196.17l-17.2,36.48-4-16.47a2.5,2.5,0,0,0-3.44-1.68l-15.57,6.93,19-39.07A40.15,40.15,0,0,0,118,196.17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualification);
export default __webpack_public_path__ + "static/media/qualification.e4ba581a4447cb6c58732735fdb788f1.svg";
export { ForwardRef as ReactComponent };